import {
  AlertDialog,
  AlertDialogBody,
  AlertDialogContent,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogOverlay,
  Button,
  useToast
} from '@chakra-ui/react'
import { useState } from 'react'

import { JobApplicationService } from '../../../services/JobApplication/JobApplicationService'
import { JobApplication } from '../../../services/JobApplication/types'

export interface IDeleteJobApplicationDialogProps {
  isOpen: boolean
  onClose: () => void
  jobApplication: JobApplication
  leastDestructiveRef: any
}

export function JobApplicationDeleteDialog({
  isOpen,
  onClose,
  jobApplication,
  leastDestructiveRef
}: IDeleteJobApplicationDialogProps) {
  const service = new JobApplicationService()
  const [isLoading, setIsLoading] = useState(false)
  const toast = useToast()

  const handleDelete = async () => {
    setIsLoading(true)
    try {
      await service.delete(jobApplication.id)

      toast({
        title: 'Vaga excluída com sucesso',
        status: 'success',
        duration: 5000,
        isClosable: true
      })

      onClose()
    } catch (error) {
      toast({
        title: 'Erro ao excluir vaga',
        status: 'error',
        duration: 5000,
        isClosable: true
      })
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <AlertDialog leastDestructiveRef={leastDestructiveRef} isOpen={isOpen} onClose={onClose} isCentered>
      <AlertDialogOverlay>
        <AlertDialogContent>
          <AlertDialogHeader fontSize="lg" fontWeight="bold">
            Remover vaga &quot;{jobApplication.name}&quot;
          </AlertDialogHeader>

          <AlertDialogBody>Tem certeza que deseja fazer isso?</AlertDialogBody>

          <AlertDialogFooter>
            <Button onClick={onClose} variant="outline">
              Cancelar
            </Button>
            <Button colorScheme="red" onClick={handleDelete} ml={3} isLoading={isLoading}>
              Sim
            </Button>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialogOverlay>
    </AlertDialog>
  )
}
